export default class PdfUtils {

    static base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    static openPDFInNewTabSetFileType(fileType) {
        var bytes = this.base64ToArrayBuffer(fileType);
        const blobUrl = URL.createObjectURL( new Blob([bytes], {type: 'application/pdf'} ));

        // open the blob in a new tab
        window.open(blobUrl, '_blank');

        URL.revokeObjectURL(blobUrl);
    }

}